<template>
<div id="email-body" class="email contatto">
   <a :href="evento.website" style="margin:10px 0 0 0;"><img :src="'https://wvpac.mzevents.it/images/'+evento.id+'/head.png'" style="width:380px;border:none;" /></a>
   <br /><br />

          Dear {{contatto.nome }} {{contatto.cognome }}
          <br /><br />
          These are your personal credentials to access the <a :href="'https://wvpac.mzevents.it/abstract-submit-2023/login/'+evento.id">{{evento.nome}}</a>  abstract management system. 
          <br /><br />


      <table cellmargin="8" cellspacing="8" width="720" align="center"><tr> 
        <tr>
          <td width="40%">
            <div style="text-align:center;">EMAIL</div>
          </td>
          <td width="60%">
            {{contatto.email}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            <div style="text-align:center;">PASSWORD</div>
          </td>
          <td width="60%">
            {{contatto.password}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            &#160;
          </td>
          <td width="60%">
            &#160;
          </td>    
        </tr>
      </table>



          Best regards
          <br />
          The secretariat
       <br /><br />
   <hr />
   <div class="yo-text-s yo-color-primary">
   VET INTERNATIONAL SRL
   <br />
   <a href="mailto:wvpac2023abstracts@vetinternational.eu" class="yo-color-primary">wvpac2023abstracts@vetinternational.eu</a> | tel. +39.02.66802323 | fax +39.02.6686699
   </div>

</div>
</template>

<script>
export default {
   props: ['contatto','evento'],
   beforeDestroy: function(){
     console.log("VM DISTRUTTA")
   }
}
</script>
